// An empty state: one sentence and, where there is something to do, one button.

import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon.tsx';

export function EmptyState({
  text,
  action,
  info,
  testId,
  icon = 'inbox',
}: {
  readonly text: string;
  readonly action?: { readonly label: string; readonly onClick: () => void };
  /** Longer text, behind an (i). */
  readonly info?: ReactNode;
  readonly testId?: string;
  readonly icon?: IconName;
}): ReactNode {
  return (
    <div className="empty-state" data-testid={testId}>
      <span className="tile neutral" aria-hidden="true">
        <Icon name={icon} size={18} />
      </span>
      <p>
        {text}
        {info === undefined ? null : <> {info}</>}
      </p>
      {action === undefined ? null : (
        <button type="button" className="btn" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
